import { html } from 'lit';
import { api } from '@converse/headless';
import { CustomElement } from 'shared/components/element.js';

class ConverseLogo extends CustomElement {
    render() {
        return html`<img src="${api.settings.get('assets_path')}/logos/${window.location.hostname}.png" height="150%">`;
    }
}

api.elements.define('converse-logo', ConverseLogo);
